/**
 * ライブラリを導入した背景
 *  Githubのソースコード（https://github.com/yocontra/react-responsive）を一通り眺めた上で、
 *  置換するコストも高くなく、最悪自前になってもそこまで負担にならないため、採用している
 *  SSRの対応も可能であるのも1つ魅力のポイント
 */
import { useMediaQuery } from 'react-responsive';

/**
 * NOTE: Tailwindのブレークポイント（https://tailwindcss.com/docs/screens）
 * module.exports = {
 *   theme: {
 *     screens: {
 *       'sm': '640px',
 *       // => @media (min-width: 640px) { ... }
 *       'md': '768px',
 *       // => @media (min-width: 768px) { ... }
 *       'lg': '1024px',
 *       // => @media (min-width: 1024px) { ... }
 *       'xl': '1280px',
 *       // => @media (min-width: 1280px) { ... }
 *       '2xl': '1536px',
 *       // => @media (min-width: 1536px) { ... }
 *     }
 *   }
 * }
 */
export const useDesktopOrMobileMediaQuery = () => {
  const isMobile = useMediaQuery({
    maxWidth: 768
  });
  const isDesktop = useMediaQuery({
    minWidth: 769
  });
  return {
    isMobile,
    isDesktop
  };
};